export enum Terms {
    AllConditions = 1,
    Privacy = 2,
    Cancellation = 3
}